<template>
  <div class="full cg-layers">
    <BGTemplate class="cg-layer full" v-if="toucher" :toucher="toucher" @ready="(v) => { engine = v; init() }">
    </BGTemplate>

    <div class="cg-layer" ref="toucher"></div>

    <BlueBubbles v-if="engine && engine.renderer && engine.scene && engine.camera" :camera="engine.camera" :amount="20" :renderer="engine.renderer" :scene="engine.scene"></BlueBubbles>
    <CrystalShards v-if="rootThreeDee && geometry && engine && engine.renderer && engine.scene && engine.camera" :rootThreeDee="rootThreeDee" :camera="engine.camera" :players="players" :amount="20" :renderer="engine.renderer" :scene="engine.scene"></CrystalShards>
    <div class="cgc-switch-color">
      <LeaderBoard @find="locateWho" v-if="activeCells && players" :activeCells="activeCells" :players="players"></LeaderBoard>
      <!-- <br /> -->
      <!-- <button @click="switchColor()">Switch Color</button> -->
    </div>

    <!-- Toolbar Icons -->
    <div class="game-top-left">
      <img class="btn-icon" src="../img/door.svg" alt="Go to Lobby" title="Go to Lobby"  @click="goHome()">
      <img class="btn-icon" src="../img/chang-name.2.svg" alt="Change Nickname" title="Change Nickname"  @click="changeMyNickName()">
      <img class="btn-icon" src="../img/color.svg" alt="Change Color" title="Change Color"  @click="switchColor()">
    </div>

    <Hover v-if="hover" :players="players" :activeCells="activeCells" :hover="hover"></Hover>

    <YoAsk v-if="yoask" @yoask="(v) => { yoask = v }" :yoask="yoask"></YoAsk>
    <YoQuestionBank v-if="yoqb" @yoqb="(v) => { yoqb = v }" :yoqb="yoqb"></YoQuestionBank>

    <!--  -->
    <YoTeach v-if="game" v-show="!(yoqb || yoask)" :room="slugify(`${game.displayName}_${game._id}`)" :cta="'Chat'" :styler="{ fontSize: '15px', width: '60px', lineHeight: '60px', height: '60px',  borderRadius: '60px', position: 'absolute', bottom: '0px', right: '0px' }"></YoTeach>
    <!-- <div class="full cg-layer">
    </div> -->
  </div>
</template>

<script>
import * as sAPI from '../api/strapi'
import slugify from 'slugify'
import _ from 'lodash'
import * as LOAD from '../api/loadEXT.js'

var hashObject = require('hash-object')
var jsondiffpatch = require('jsondiffpatch').create()
var TWEEN = require('@tweenjs/tween.js')
var THREE = {
  ...require('three')
}
var FSCalc = ({ zPos, camera }) => {
  var cameraZ = camera.position.z
  var distance = cameraZ - zPos
  var aspect = window.innerWidth / window.innerHeight
  var vFov = camera.fov * Math.PI / 180
  var planeHeightAtDistance = 2 * Math.tan(vFov / 2) * distance
  var planeWidthAtDistance = planeHeightAtDistance * aspect

  /*
  let dist = camera.position.z - mesh.position.z
  let height = ... // desired height to fit
  camera.fov = 2 * Math.atan(height / (2 * dist)) * (180 / Math.PI)
  camera.updateProjectionMatrix()
  */

  return {
    aspect: planeWidthAtDistance / planeHeightAtDistance,
    vmin: Math.min(planeWidthAtDistance, planeHeightAtDistance),
    vmax: Math.max(planeWidthAtDistance, planeHeightAtDistance),
    width: planeWidthAtDistance,
    height: planeHeightAtDistance
  }
}

export default {
  components: {
    YoTeach: () => {
      return new Promise((resolve) => {
        let lib = 'https://yoteach-cloud-widget-lib.netlify.com/yoteach.umd.min.js'
        new LOAD.ext([lib, 'https://yoteach-cloud-widget-lib.netlify.com/yoteach.css'], function() {
          resolve(window.yoteach)
        })
      })

      //
      // https://yoteach-cloud-widget-lib.netlify.com/yoteach.umd.min.js
      // https://yoteach-cloud-widget-lib.netlify.com/yoteach.css
      // <yo room="RandomRoom_Alisha_Aluin_Glanville"></yo>
      //
    },
    // Scene: () => import(/* webpackChunkName: "cloud" */ '../vfx/Common/Scene.vue'),
    // Object3D: () => import(/* webpackChunkName: "cloud" */ '../vfx/Common/Object3D.vue'),

    BlueBubbles: () => import(/* webpackChunkName: "cloud" */ '../game/BlueBubbles.vue'),
    BGTemplate: () => import(/* webpackChunkName: "cloud" */ '../game/BGTemplate.vue'),
    CrystalShards: () => import(/* webpackChunkName: "cloud" */ '../game/CrystalShards.vue'),
    LeaderBoard: () => import(/* webpackChunkName: "cloud" */ '../ui/LeaderBoard.vue'),
    Hover: () => import(/* webpackChunkName: "cloud" */ '../ui/Hover.vue'),
    YoQuestionBank: () => import(/* webpackChunkName: "cloud" */ '../ui/YoQuestionBank.vue'),
    YoAsk: () => import(/* webpackChunkName: "cloud" */ '../ui/YoAsk.vue'),
  },
  data () {
    return {
      rootThreeDee: false,
      geometry: false,
      slugify,
      toucher: false,
      yoask: false,
      yoqb: false,
      hover: false,
      activeCells: false,
      leftGame: false,
      loading: false,
      IO: false,
      players: false,
      game: false,
      clickables: false,
      clickablesAround: false,
      cidToStride1: new Map(),
      xy2idx: new Map(),
      ready: false,

      players: false,
      IO: false,
      engine: false,
      boardGL: false
    }
  },
  mounted () {
    this.toucher = this.$refs['toucher']
  },
  computed: {
    gameID () {
      return this.$route.params.gameID
    },
    isDead () {
      if (!this.game) {
        return false
      }
      if (!this.players) {
        return false
      }
      if (!this.ready) {
        return false
      }
      return !this.game.cells.some(e => e.uid === sAPI.LS.UserID)
    }
  },
  watch: {
    game: {
      deep: true,
      handler () {
        this.clickables = this.getClickableAreas()
        this.clickablesAround = this.getClickableAroundAreas()
        this.activeCells = this.getActiveCells()
        this.$forceUpdate()

        if (this.game && this.players) {
          this.makeBoardGL()
        }
      }
    },
    players: {
      deep: true,
      handler () {
        if (this.game && this.players) {
          this.makeBoardGL()
        }
      }
    }
  },
  methods: {
    changeMyNickName () {
      let player = this.players.find(p => p.userID === sAPI.LS.UserID)
      player.displayName = window.prompt(`What's your nickname?`) || 'Player'
      this.IO.emit('patch-player', { gameID: this.gameID, token: sAPI.LS.JWT, userID: sAPI.LS.UserID, player })
    },
    goHome () {
      this.$router.push('/cloud/lobby')
    },
    tweenGlow () {
      // if (this.t1) {
      //   this.t1.stop()
      // }
      // if (this.t2) {
      //   this.t2.stop()
      // }

      // let coord1 = {
      //   ...this.engine.Settings.bloomModes['shine']
      // }
      // let coord2 = {
      //   ...this.engine.Settings.bloomModes['default']
      // }

      // this.t1 = new TWEEN.Tween(this.engine.bloomPass)
      //   .to({ ...coord1 }, 500)
      //   .easing(TWEEN.Easing.Quadratic.Out)
      //   .onUpdate(() => {
      //     // for (var kn in coord1) {
      //     //   this.engine.bloomPass[kn] = coord1[kn]
      //     // }
      //   })
      // this.t2 = new TWEEN.Tween(this.engine.bloomPass)
      //   .to({ ...coord2 }, 500)
      //   .easing(TWEEN.Easing.Quadratic.Out)
      //   .onUpdate(() => {
      //     // for (var kn in coord2) {
      //     //   this.engine.bloomPass[kn] = coord2[kn]
      //     // }
      //   })

      // function go () {
      //   let cgo = TWEEN.update()
      //   // console.log(cgo)
      //   if (cgo) {
      //     requestAnimationFrame(go)
      //   }
      // }

      // setTimeout(() => {
      //   go()
      // });

      // this.t1.chain(this.t2)
      // this.t1.start()
    },
    locateCellCore ({ player }) {
      // console.log(player)
      let userID = player.userID
      let cell = this.game.cells.find(c => c.uid === userID && c.core) || {}
      let stride = this.cidToStride1.get(cell.cid)

      let x = this.geometry.attributes.position.array[stride * 3 + 0]
      let y = this.geometry.attributes.position.array[stride * 3 + 1]
      let z = this.geometry.attributes.position.array[stride * 3 + 2]

      return {
        x,
        y,
        z
      }
    },
    locateWho ({ player, zLevel = 2000 }) {
      // console.log(player)
      let userID = player.userID
      let cell = this.game.cells.find(c => c.uid === userID && c.core) || {}
      let stride = this.cidToStride1.get(cell.cid)

      let x = this.geometry.attributes.position.array[stride * 3 + 0]
      let y = this.geometry.attributes.position.array[stride * 3 + 1]
      // let z = this.geometry.attributes.position.array[stride * 3 + 2]

      let coord = { ...this.engine.camera.position }

      setTimeout(() => {
        if (this.t1) {
          this.t1.stop()
        }
        if (this.t2) {
          this.t2.stop()
        }

        this.t1 = new TWEEN.Tween(coord)
          .to({ x, y, z: zLevel }, 1500)
          .easing(TWEEN.Easing.Quadratic.Out)
          .onUpdate(() => {
            this.engine.control.target0.x = coord.x
            this.engine.control.target0.y = coord.y
            this.engine.control.target0.z = 0
            this.engine.control.position0.x = coord.x
            this.engine.control.position0.y = coord.y
            this.engine.control.position0.z = coord.z
            this.engine.control.reset()
          })
        this.t2 = new TWEEN.Tween(coord)
          .to({ x, y, z: window.innerWidth > 500 ? 200 : 80 }, 1000)
          .easing(TWEEN.Easing.Quadratic.Out)
          .onUpdate(() => {
            this.engine.control.target0.x = coord.x
            this.engine.control.target0.y = coord.y
            this.engine.control.target0.z = 0
            this.engine.control.position0.x = coord.x
            this.engine.control.position0.y = coord.y
            this.engine.control.position0.z = coord.z
            this.engine.control.reset()
          })

        function go () {
          let cgo = TWEEN.update()
          console.log(cgo)
          if (cgo) {
            requestAnimationFrame(go)
          }
        }

        setTimeout(() => {
          go()
        })

        this.t1.chain(this.t2)
        this.t1.start()

        console.log(x,y)
        console.log(coord.x,coord.y)

      }, 1)
    },
    getActiveCells () {
      return this.game.cells.filter(e => e.uid !== 'map')
    },
    processCache () {
      this.xy2idx = new Map()
      this.game.cells.forEach((cell, idx) => {
        this.xy2idx.set(`${cell.x}-${cell.y}`, idx)
      })
    },
    getClickableAroundAreas () {
      let xy2idx = this.xy2idx
      let cells = this.game.cells
      let info = cells.filter(a => a.uid === sAPI.LS.UserID).reduce((info, tile) => {
        let found = [
          cells[xy2idx.get((tile.x + 0) + '-' + (tile.y + 1))], // up
          cells[xy2idx.get((tile.x + 0) + '-' + (tile.y - 1))], // down
          cells[xy2idx.get((tile.x + 1) + '-' + (tile.y + 0))], // right
          cells[xy2idx.get((tile.x - 1) + '-' + (tile.y + 0))] // left
        ].filter(e => e)
        info.bucket.push(...found)
        return info
      }, {
        bucket: []
      })
      info.bucket = _.uniqBy(info.bucket, 'cid')

      info.bucket = info.bucket.filter((a) => {
        return a => a.uid === 'map'
      })

      cells.forEach(e => e.clickable = false)
      info.bucket.forEach(e => e.clickable = true)
      return info.bucket
    },
    getClickableAreas () {
      let xy2idx = this.xy2idx
      let cells = this.game.cells
      let info = cells.filter(a => a.uid === sAPI.LS.UserID).reduce((info, tile) => {
        let found = [
          cells[xy2idx.get((tile.x + 0) + '-' + (tile.y + 0))], // the cell
          cells[xy2idx.get((tile.x + 0) + '-' + (tile.y + 1))], // up
          cells[xy2idx.get((tile.x + 0) + '-' + (tile.y - 1))], // down
          cells[xy2idx.get((tile.x + 1) + '-' + (tile.y + 0))], // right
          cells[xy2idx.get((tile.x - 1) + '-' + (tile.y + 0))] // left
        ].filter(e => e)
        info.bucket.push(...found)
        return info
      }, {
        bucket: []
      })
      info.bucket = _.uniqBy(info.bucket.slice(), 'cid')

      return info.bucket
    },
    makeBoardGL () {
      if (this.boardGL) {
        return
      }
      this.boardGL = true

      // ------------UI------------
      var raycaster = new THREE.Raycaster()
      // this.raycaster = raycaster;
      var mouse = new THREE.Vector2()
      this.mouse = mouse

      /* eslint-disable */
      function onMouseMove(event) {
        // calculate mouse position in normalized device coordinates
        // (-1 to +1) for both components
        mouse.x = (event.clientX / window.innerWidth) * 2 - 1
        mouse.y = - (event.clientY / window.innerHeight) * 2 + 1
      }
      window.addEventListener('mousemove', onMouseMove, false)

      function onTouchMove(event) {
        // calculate mouse position in normalized device coordinates
        // (-1 to +1) for both components
        mouse.x = (event.touches[0].clientX / window.innerWidth) * 2 - 1
        mouse.y = - (event.touches[0].clientY / window.innerHeight) * 2 + 1
      }
      window.addEventListener('touchmove', onTouchMove, false)


      function onTouchStart(event) {
        // calculate mouse position in normalized device coordinates
        // (-1 to +1) for both components
        mouse.x = (event.touches[0].clientX / window.innerWidth) * 2 - 1
        mouse.y = - (event.touches[0].clientY / window.innerHeight) * 2 + 1
      }
      window.addEventListener('touchstart', onTouchStart, false)

      let resolution = new THREE.Vector2(window.innerWidth, window.innerHeight)
      window.addEventListener('resize', () => {
        resolution.x = window.innerWidth
        resolution.y = window.innerHeight
      })

      window.addEventListener('orientationchange', () => {
        resolution.x = window.innerWidth
        resolution.y = window.innerHeight
      })

      let shouldBeClickEvent = false
      let isTouch = false
      let tt = 0
      let toucher = this.$refs['toucher']
      toucher.addEventListener('click', () => {
        if (isTouch) {
          return
        }
        onClick()
      }, false)
      toucher.addEventListener('mousemove', () => {
        clearTimeout(tt)
        shouldBeClickEvent = false
      })
      toucher.addEventListener('touchstart', () => {
        isTouch = true
        shouldBeClickEvent = true
        setTimeout(() => {
          shouldBeClickEvent = false
        }, 300)
      })
      toucher.addEventListener('touchmove', (evt) => {
        console.log(evt)
      })
      toucher.addEventListener('touchend', () => {
        if (!shouldBeClickEvent) {
          return
        }
        shouldBeClickEvent = false
        onClick()
      }, false)

      let onClick = () => {
        let intersects = this.intersects || []
        if (intersects.length > 0) {
          // console.log(intersects[0])
          let idx = intersects[0].index
          let cell = this.game.cells[idx]

          // console.log(({ numID: cell.numID, 'xid': cell.xid, 'yid': cell.yid, cell }))

          this.tweenGlow()

          this.onGLClickCell({
            cell
          })
        }
        // console.log('clicked')
      }



      // ------------GEO------------
      var counter = this.game.width * this.game.height

      console.log(this.game)

      var PARTICLE_SIZE = 25.0
      var positions = new Float32Array(counter * 3)
      var cellStatus = new Float32Array(counter * 4)
      var cellColors = new Float32Array(counter * 3)
      var cellBorderColors = new Float32Array(counter * 3)
      var stride1 = 0;
      var stride3 = 0;
      let cells = this.game.cells
      let cidToStride1 = this.cidToStride1
      let defaultCellColor = 0x100B36
      let defaultCellBorderColor = 0x0A0721
      var color = new THREE.Color(defaultCellColor)
      var width = this.game.width
      var height = this.game.height
      for (var y = 0; y < height; y++) {
        for (var x = 0; x < width; x++) {
          var sizePlusPad = PARTICLE_SIZE

          var cell = cells[stride1]

          var { px, py, pz } = {
            px: cell.x * sizePlusPad - (width) * sizePlusPad * 0.5,
            py: cell.y * sizePlusPad - (height) * sizePlusPad * 0.5,
            pz: 0
          }
          cidToStride1.set(cell.cid, stride1)

          positions[stride3 + 0.0] = px * 1.05
          positions[stride3 + 1.0] = py * -1.05
          positions[stride3 + 2.0] = pz

          color.setHex(defaultCellColor)

          cellColors[stride3 + 0.0] = color.r
          cellColors[stride3 + 1.0] = color.g
          cellColors[stride3 + 2.0] = color.b

          color.setHex(defaultCellBorderColor)

          cellBorderColors[stride3 + 0.0] = color.r
          cellBorderColors[stride3 + 1.0] = color.g
          cellBorderColors[stride3 + 2.0] = color.b

          cellStatus[stride3 + 0.0] = cell.lvl
          cellStatus[stride3 + 1.0] = cell.core ? 1 : 0
          cellStatus[stride3 + 2.0] = 0
          cellStatus[stride3 + 3.0] = 0

          stride1 += 1
          stride3 += 3
        }
      }

      var geometry = new THREE.BufferGeometry()
      geometry.addAttribute('position', new THREE.BufferAttribute(positions, 3).setDynamic(false))
      geometry.addAttribute('cellStatus', new THREE.BufferAttribute(cellStatus, 4).setDynamic(true))
      geometry.addAttribute('cellColor', new THREE.BufferAttribute(cellColors, 3).setDynamic(true))
      geometry.addAttribute('cellBorderColor', new THREE.BufferAttribute(cellBorderColors, 3).setDynamic(true))
      this.geometry = geometry

      let uniforms = {
        upgrades: {
          value: null
          // value: new THREE.TextureLoader().load(require('../texture/debug2.png'))
        },
        time: {
          value: 0
        },
        screen: {
          value: new THREE.Vector2(10, 10)
        },
        resolution: {
          value: resolution
        }
      }
      let info = FSCalc({ zPos: 0, camera: this.engine.camera })
      uniforms.screen.value.x = info.width
      uniforms.screen.value.y = info.height

      raycaster.params.Points.threshold = PARTICLE_SIZE * 0.5

      let material = new THREE.ShaderMaterial({
        defines: {
          // sAPI.Game.maxCellCoreLevel
          [`CELL_LEVEL_SLOTS`]: `${(5 + 1).toFixed(1)}`, // based on image not variable of sAPI.Game.Maxlevel
          [`CAM_Z_POS`]: `${(this.engine.camera.position.z * 10).toFixed(1)}`,
          [`PARTICLE_SIZE`]: `${PARTICLE_SIZE.toFixed(1)}`
        },
        uniforms,
        transparent: true,
        vertexShader: `
          uniform vec2 resolution;
          uniform vec2 screen;
          uniform float time;

          attribute vec3 cellColor;
          varying vec3 vCellColor;

          attribute vec3 cellBorderColor;
          varying vec3 vCellBorderColor;

          attribute vec4 cellStatus;
          varying vec4 vCellStatus;

          varying vec2 vUv;

          void main(){
            vUv = uv;
            vCellColor = cellColor;
            vCellBorderColor = cellBorderColor;
            vCellStatus = cellStatus;

            vec3 nPos = position;
            vec4 mvPosition = modelViewMatrix * vec4(nPos, 1.0);
            vec4 clipper = projectionMatrix * mvPosition;

            float aspect = resolution.y / resolution.x;
            float sy = resolution.y / screen.y;
            float sa = CAM_Z_POS / -mvPosition.z;
            float dpi = 2.0;
            float pointSize = PARTICLE_SIZE;

            if (aspect > 1.0) {
              gl_PointSize = pointSize * dpi / 10.0 * sy * sa;
            } else {
              gl_PointSize = pointSize * dpi / 10.0 * sy * sa;
            }

            gl_Position = clipper;
          }
        `,
        fragmentShader: `
          uniform float time;
          varying vec3 vCellColor;
          varying vec3 vCellBorderColor;
          varying vec4 vCellStatus;
          varying vec2 vUv;
          uniform sampler2D upgrades;

          void main() {
            float dist = length(gl_PointCoord.xy - 0.5);
            if (dist > 0.5) {
              discard;
            } else {
              // vCellStatus.x = lvl
              // vCellStatus.y = core = 1.0, or not = 0
              // vCellStatus.z = hovered
              // vCellStatus.w = owned

              float hovered = vCellStatus.z;
              float isCore = vCellStatus.y;
              float owned = vCellStatus.w;

              vec2 coord = vec2(gl_PointCoord.x, 1.0 - gl_PointCoord.y);

              float lvl = vCellStatus.x;

              coord.y = fract((CELL_LEVEL_SLOTS - lvl - 1.0) / CELL_LEVEL_SLOTS + coord.y / CELL_LEVEL_SLOTS);

              vec4 texColor = texture2D(upgrades, coord);

              if (hovered == 1.0) {
                if (dist > 0.43) {
                  gl_FragColor = vec4(vCellBorderColor * gl_PointCoord.xyy * 30.0 * vec3(abs(sin(-time) * cos(time)), abs(-sin(time)* cos(time)), abs(cos(time) * sin(time))), 1.0);
                } else {
                  if (owned == 1.0) {
                    if ((1.0 - texColor.r) < 0.1) {
                      gl_FragColor = vec4(vec3(0.0), 1.0);
                    } else {
                      gl_FragColor = vec4(vec3(vCellColor), 1.0);
                    }
                  } else {
                    gl_FragColor = vec4(vec3(vCellColor), 1.0);
                  }
                }
              } else if (vCellStatus.y == 1.0) {
                if (dist > 0.43) {
                  gl_FragColor = vec4(vCellBorderColor, 1.0);
                } else {
                  if ((1.0 - texColor.r) < 0.1) {
                    gl_FragColor = vec4(vec3(0.0), 1.0);
                  } else {
                    gl_FragColor = vec4(vec3(1.0), 1.0);
                  }
                }
              } else {
                if (vCellStatus.w == 1.0) {
                  // if (dist > 0.43) {
                  //   gl_FragColor = vec4(vCellBorderColor, 1.0);
                  // } else {
                  //   if ((1.0 - texColor.r) < 0.1) {
                  //     gl_FragColor = vec4(vec3(vCellColor * 0.2), 1.0);
                  //   } else {
                  //     gl_FragColor = vec4(vec3(vCellColor), 1.0);
                  //   }
                  // }

                  if (dist > 0.43) {
                    gl_FragColor = vec4(vCellBorderColor, 1.0);
                  } else {
                    gl_FragColor = vec4(vec3(vCellColor), 1.0);
                  }
                } else {
                  if (dist > 0.43) {
                    gl_FragColor = vec4(vCellBorderColor, 1.0);
                  } else {
                    gl_FragColor = vec4(vec3(vCellColor), 1.0);
                  }
                }
              }

            }
          }
        `
      });

      let tempBallColor = new THREE.Color()
      let setCellColorByCID = (cellCID, myColor, { h, s, l } = { h: 0, s: 0, l: 0 }) => {
        let attributes = geometry.attributes
        let stride = this.cidToStride1.get(cellCID)

        tempBallColor.set(myColor)
        tempBallColor.offsetHSL(h, s, l)
        let { r, g, b } = tempBallColor
        attributes.cellColor.array[stride * 3.0 + 0.0] = r
        attributes.cellColor.array[stride * 3.0 + 1.0] = g
        attributes.cellColor.array[stride * 3.0 + 2.0] = b
        attributes.cellColor.needsUpdate = true
      }
      let setCellBorderColorByCID = (cellCID, myColor, { h, s, l } = { h: 0, s: 0, l: 0 }) => {
        let attributes = geometry.attributes
        let stride = this.cidToStride1.get(cellCID)

        tempBallColor.set(myColor)
        tempBallColor.offsetHSL(h, s, l)
        let { r, g, b } = tempBallColor
        attributes.cellBorderColor.array[stride * 3.0 + 0.0] = r
        attributes.cellBorderColor.array[stride * 3.0 + 1.0] = g
        attributes.cellBorderColor.array[stride * 3.0 + 2.0] = b
        attributes.cellBorderColor.needsUpdate = true
      }

      let setCellStatusByCID = (cellCID, lvl, core, hover, owner) => {
        let attributes = geometry.attributes
        let stride = this.cidToStride1.get(cellCID)

        let { r, g, b } = tempBallColor
        attributes.cellStatus.array[stride * 4.0 + 0.0] = lvl
        attributes.cellStatus.array[stride * 4.0 + 1.0] = core ? 1 : 0
        attributes.cellStatus.array[stride * 4.0 + 2.0] = hover
        attributes.cellStatus.array[stride * 4.0 + 3.0] = owner ? 1 : 0
        attributes.cellStatus.needsUpdate = true
      }

      let getPlayerByUID = (uid) => {
        return this.players.find(p => p.userID === uid)
      }
      // console.log(this.players)

      let cacheMap = new WeakMap();
      let userDataToStyles = () => {
        let colors = this.players.map(p => p.color).join('.')
        let cells = this.game.cells

        let me = getPlayerByUID(sAPI.LS.UserID)
        let myID = sAPI.LS.UserID

        cells.forEach(cell => {
          let print = cell.lvl + cell.core + cell.isHovered + cell.uid + colors + cell.clickable + 'owned' + (cell.uid !== 'map')
          if (cacheMap.get(cell) === print) {
            return
          } else {
            cacheMap.set(cell, print)
          }

          setCellStatusByCID(cell.cid, cell.lvl, cell.core, cell.isHovered, cell.uid !== 'map');
          cell.isHovered = false

          let player = getPlayerByUID(cell.uid)
          setCellColorByCID(cell.cid, defaultCellColor);
          setCellBorderColorByCID(cell.cid, defaultCellBorderColor);
          // owned cells
          if (cell.uid !== 'map') {
            if (cell.core) {
              setCellColorByCID(cell.cid, player.color, { h: 0, s: 1, l: (cell.lvl / sAPI.Game.maxCellCoreLevel) * 4.0 - 2.0 });
              setCellBorderColorByCID(cell.cid, player.color, { h: 0, s: 0.0, l: -0.15 });
            } else {
              if (cell.lvl > 0) {
                setCellColorByCID(cell.cid, player.color, { h: 0, s: 0, l: 0.0 });
                setCellBorderColorByCID(cell.cid, player.color, { h: 0, s: -0.3, l: 2 });
              } else {
                setCellColorByCID(cell.cid, player.color, { h: 0, s: 0, l: 0.0 });
                setCellBorderColorByCID(cell.cid, player.color, { h: 0, s: -0.3, l: 0.0 });
              }
            }
          } else if (cell.uid === 'map' && this.clickablesAround.some(c => c.cid === cell.cid)) {
            setCellColorByCID(cell.cid, me.color, { h: 0.1, s: 0, l: -0.1 });
            setCellBorderColorByCID(cell.cid, me.color, { h: 0.1, s: -0.3, l: -0.3 });
          }
        });
      }

      // let highlightID =

      this.engine.execMap.boardRender = () => {
        userDataToStyles()

        raycaster.setFromCamera(mouse, this.engine.camera)
        let intersects = raycaster.intersectObject(this.pointcloud)
        this.intersects = intersects

        // console.log(this.activeTiles)

        if (intersects.length > 0) {
          let idx = intersects[0].index
          let cell = this.game.cells[idx]
          this.game.cells.forEach(c => c.isHovered = false)
          if (cell) {
            this.hover = cell
            cell.isHovered = true
            // setCellStatusByCID(cell.cid, cell.lvl, cell.core, 1.0);
          } else {
          }

          toucher.style.cursor = `pointer`
        } else {
          this.hover = false
          toucher.style.cursor = 'auto'
        }

        uniforms.time.value = window.performance.now() * 0.001
        material.needsUpdate = true
      }

      this.pointcloud = new THREE.Points(geometry, material)
      this.rootThreeDee = new THREE.Object3D()

      // this.rootThreeDee.rotation.x = Math.PI / 180 * -30
      // this.rootThreeDee.scale.multiplyScalar(1.1)

      this.rootThreeDee.add(this.pointcloud)
      this.engine.scene.add(this.rootThreeDee)
      this.tryLocateMySelf()
    },
    tryLocateMySelf () {
      let player = this.players.find(p => p.userID === sAPI.LS.UserID)
      if (player) {
        try {
          this.locateWho({ player })
        } catch (e) {
          console.log('too-early', e)
        }
      }
    },
    getPlayerByCell ({ cell }) {
      let uid = cell.uid
      if (this.players) {
        let player = this.players.find(p => p.userID === uid)
        if (player) {
          return player
        } else {
          return false
        }
      } else {
        return false
      }
    },
    getUserDisplayName ({ cell }) {
      let uid = cell.uid
      if (this.players) {
        let player = this.players.find(p => p.userID === uid)
        if (player) {
          return player.displayName
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    onGLClickCell ({ cell }) {
      console.log('onGLClickCell', cell)
      this.game.flags = this.game.flags || {}
      if (this.game.flags.frozen) {
        window.alert('this game is frozen');
        return
        // this.yoask = {
        //   mode: 'frozen',
        //   yes: () => {},
        //   no: () => {}
        // }
      }

      let myself = this.players.find(p => p.userID === sAPI.LS.UserID)
      let { mode, displayMsg, closeOnly } = sAPI.getDifficultyAndMode({ cell, players: this.players, myself, game: this.game })

      if (this.clickables.some(c => c.cid === cell.cid)) {
        this.yoask = {
          mode: 'confirmGoAhead',
          displayMsg,
          cell: cell,
          closeOnly,
          getMessage: () => {
          },
          yes: () => {
            this.openYoQB({ cell })
          },
          no: () => {
            this.yoask = false
          }
        }
      }
      // this.onSendServerClickCell({ cell })
    },
    openYoQB ({ cell }) {
      this.yoqb = {
        mode: 'question',
        cell: cell,
        game: this.game,
        myUserID: sAPI.LS.UserID,
        myself: this.players.find(p => p.userID === sAPI.LS.UserID),
        players: this.players,
        yes: () => {
          this.onSendServerClickCell({ cell })
        },
        no: () => {
          this.yoqb = false
        }
      }
    },
    switchColor () {
      let _newColor = new THREE.Color()
      let getRandomColor = () => {
        _newColor.setHSL(Math.random(), 0.8, 0.4)
        return `#${_newColor.getHexString()}`
      }
      let player = this.players.find(p => p.userID === sAPI.LS.UserID)
      player.color = getRandomColor()
      this.IO.emit('patch-player', { gameID: this.gameID, token: sAPI.LS.JWT, userID: sAPI.LS.UserID, player })
    },
    onSendServerClickCell ({ cell }) {
      if (this.isDead) {
        window.alert(`you're dead, refresh to restart game`)
        return
      }

      this.IO.emit('on-click-cell', {
        gameID: this.gameID,
        token: sAPI.LS.JWT,
        cell: cell,
        userID: sAPI.LS.UserID
      })
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 3000)
    },

    // getCellStyle ({ cell }) {
    //   this.clickables = this.clickables || []
    //   let canClick = this.clickables.some(c => c.cid === cell.cid)
    //   let player = this.getPlayerByCell({ cell })
    //   let borderColor = 'silver'
    //   if (canClick) {
    //     borderColor = 'black'
    //   }
    //   let boxShadow = `0px 0px 0px 1px white inset`
    //   return {
    //     backgroundColor: player ? player.color : 'white',
    //     backgroundImage: cell.core ? `radial-gradient(white, ${player.color})` : '',
    //     color: 'white',
    //     textShadow: '0px 0px 2px black',
    //     border: 'black solid 1px',
    //     borderColor,
    //     boxShadow
    //   }
    // },

    cell (x, y) {
      return this.game.cells.find(c => c.x === x && c.y === y)
    },
    askForPW () {
      return new Promise((resolve) => {
        this.yoask = {
          mode: 'enter-password',
          yes: (pw) => {
            resolve(pw)
          },
          no: () => {
            resolve(false)
          }
        }
      })
    },
    async checkPW () {
      let gameDetail = await sAPI.getGameDetail({ gameID: this.gameID })
      console.log(gameDetail)
      if (gameDetail.enableEntryPassword) {
        let pw = await this.askForPW()

        // let pw = window.prompt(`Please enter entry password`)
        let ok = false
        try {
          ok = await sAPI.checkPassword({ gameID: this.gameID, entryPassword: pw })
        } catch (e) {
          ok = false
        }
        console.log(ok)
        return {
          skip: !ok
        }
      } else {
        return {
          skip: false
        }
      }
    },

    async init () {
      let { skip } = await this.checkPW()
      if (skip) {
        this.$router.push('/cloud/lobby');
        return
      }

      this.IO = await sAPI.getIO()
      this.IO.on('connect', () => {
        this.IO.emit('join-game', { gameID: this.gameID, token: sAPI.LS.JWT, level: sAPI.Game.startLevel }, (data) => {
          if (this.leftGame) {
            return
          }
          this.game = data.game
          this.processCache()
          this.$forceUpdate()
        })

        this.IO.on('player-patch', ({
          gameID,
          userID,
          player
        }) => {
          if (this.leftGame) {
            return
          }
          if (this.gameID === gameID) {
            let idx = this.players.findIndex(p => p.userID === player.userID)
            this.players[idx] = player
            this.players = this.players.slice()
            this.$forceUpdate()
          }
        });

        this.IO.on('players', ({ players }) => {
          if (this.leftGame) {
            return
          }
          this.players = players
          this.tryLocateMySelf()
        })

        this.IO.on('mapview-delta', ({ gameID, notify }) => {
          if (this.leftGame) {
            return
          }
          // console.log(gameID, notify)
          if (this.game._id === gameID) {
            let newCells = jsondiffpatch.patch(this.game.cells, notify.cellPatch)
            if (hashObject(newCells) === notify.mapDoneHash) {
              this.game.cells = newCells
              this.loading = false
              this.ready = true
              this.$forceUpdate()
              this.tweenGlow()
            }
          }
        })
      })
    }
  },
  beforeDestroy () {
    this.leftGame = true
    // this.IO.disconnect()
  }
}
</script>

<style scoped>
/* @import url(../css/main.css); */
.cg-layers{
  position: absolute;
  top: 0px;
  left: 0px;
}
.cg-layer{
  width: 100%;
  height: 100%;
}
</style>
